import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalDepositFiat = defineStore('modalDepositFiat', {
  state: () => ({
    creditCard: {
      savedCardsTitle: '',
      cardholderNameTitle: '',
      creditCardTitle: '',
      cardNumberTitle: '',
      amountTitle: '',
      expireYearTitle: '',
      expireMonthTitle: '',
      threeDSecureText: '',
      cvvTitle: '',
      newCardTitle: '',
      cvvInfoTooltip: '',
    },
    directPayment: {
      emailTitle: '',
      newEmailTitle: '',
      accountTitle: '',
      accountNumberTitle: '',
      voucherTitle: '',
      phoneTitle: '',
      serviceTitle: '',
      walletIdTitle: '',
      walletPwdTitle: '',
      stateTitle: '',
    },
    commonData: {
      minDepositTitle: '',
      maxDepositTitle: '',
      paymentCurrencyTitle: '',
      paymentMethodsTitle: '',
      comissionTitle: '',
      savedPaymentMethodsTitle: '',
      otherPaymentMethodsTitle: '',
    },
    paymentErrors: {
      too_big_amount: '',
      cvv: '',
      payment_system_limit_error: '',
      payment_method: '',
      too_small_amount: '',
      phoneNumber: '',
      player_limit: '',
      card_number: '',
      email: '',
      system_error: '',
      unknown_payment_system_error: '',
    },
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadDepositFiatModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'creditCard',
          'directPayment',
          'commonData',
          'paymentErrors',
        ]);

        this.requestPromise = strapi()
          .get('deposit-fiat-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
